module.exports = __webpack_public_path__ + "img/Lane Hall 2.eb0110c9.png";